import React, { forwardRef, useState, useEffect } from 'react'
import { Cascader } from '@ow/comps'
import { css, Global } from '@emotion/react'

const Render = function (
  { opts = {}, onChange, value, onFetchRemoteData, style = {} },
  ref
) {
  const { multiple } = opts
  const [areas, setAreas] = useState([])

  useEffect(() => {
    // 获取远程数据
    if (onFetchRemoteData) {
      const area = onFetchRemoteData('area')
      area.fetchTreeData().then((data) => {
        setAreas(data)
      })
    }
  }, [])

  return (
    <div className="w-full" ref={ref}>
      <Global
        styles={css`
          .cas-dropdown {
            .rc-tree-select-tree-treenode {
              width: fit-content !important;
            }
          }
        `}
      />
      <Cascader
        tree={areas}
        inputStyle={{
          width: '100%',
          height: '36px',
          ...style,
        }}
        multiple={multiple}
        treeCheckable={multiple}
        fieldNames={{
          label: 'title',
          value: 'objectId',
          children: 'children',
        }}
        placeholder={opts.hint || `请选择${opts.title}`}
        onChange={(selectedKeys) => {
          if (selectedKeys) {
            onChange(multiple ? selectedKeys : [selectedKeys])
          } else {
            onChange([])
          }
        }}
        value={value || undefined}
        notFoundContent="暂无数据"
        showCheckedStrategy="SHOW_PARENT"
        bubble
      />
    </div>
  )
}

export default forwardRef(Render)
